// Roofline chevron divider — brand motif used between sections.
export default function RoofDivider({ from = "#ffffff", to = "#f8fafc", flip = false }) {
  return (
    <div aria-hidden="true" className="relative -mt-px" style={{ background: from }}>
      <svg
        viewBox="0 0 1200 70"
        preserveAspectRatio="none"
        className={`block h-[46px] w-full sm:h-[64px] ${flip ? "rotate-180" : ""}`}
      >
        <path d="M0,70 L600,0 L1200,70 Z" fill={to} />
        <path d="M0,70 L600,0 L1200,70" fill="none" stroke="#AECE2F" strokeWidth="3" />
      </svg>
    </div>
  );
}
